import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.gif.blue.background,
    color: theme.palette.gif.blue.color,
    height: 30,
    width: 30,
  },
}));

function InitialsBox(props) {
  const { name } = props;
  const classes = useStyles();
  const [initials, setInitials] = useState(null);
  useEffect(() => {
    const parts = name?.toUpperCase().split(" ") || [];

    const initials = parts
      .slice(parts.length - 2)
      .map((p) => p[0])
      .join("");
    setInitials(initials);
  }, [name]);
  return (
    <Paper elevation={0} className={classes.root}>
      {initials}
    </Paper>
  );
}

export default InitialsBox;
